import {statusToLoading} from 'adapter/loading.adapter';

export function useLoadingQuery(props) {
  const {status, isLoading} = props;

  return {...props, loading: statusToLoading(status, isLoading)};
}
